<template>
  <header class="mobile-header">
    <div class="header-bar">
      <div class="header-inner">
        <router-link to="/" class="logo" aria-label="카시아 속초 오너스 멤버십">
          <span class="logo-img"></span>
        </router-link>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'MobileHeader'
}
</script>

<style scoped>
.mobile-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}

.header-bar {
  background: #ffffff;
  border-bottom: 1px solid rgba(0, 48, 48, 0.2);
  transition: background 0.3s ease;
}

.header-inner {
  position: relative;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
}

.logo {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  text-decoration: none;
}

.logo-img {
  display: block;
  width: min(40vw, 150px);
  aspect-ratio: 601 / 223;
  background: url('@/assets/logo/logo.png') no-repeat center / contain;
}
</style>
